module.exports = __webpack_public_path__ + "img/one_8.b3d8bd0d.png";